import { Store, createState, withProps, select } from '@ngneat/elf';

import { GetCandidateProfileDataQuery } from 'lib/generated/graphql';

/**
 * Define props
 */
export interface CandidateStoreProps {
  candidate:
    | GetCandidateProfileDataQuery['getCandidateProfileData']['candidate']
    | undefined;
}

export type SkillType =
  GetCandidateProfileDataQuery['getCandidateProfileData']['candidate']['skills'][0];

/**
 * Create store and persist state in local storage
 */
const { state, config } = createState(
  withProps<CandidateStoreProps>({ candidate: undefined })
);

const CandidateStore = new Store({
  name: 'CandidateStore',
  state,
  config,
});

/**
 * Export data
 */
export const $candidate = CandidateStore.pipe(select((s) => s.candidate));

export function setCandidate(
  candidate: CandidateStoreProps['candidate']
): void {
  CandidateStore.update((s) => ({ ...s, candidate }));
}

export function updateCandidateProfile(
  fieldsToUpdate: Partial<CandidateStoreProps['candidate']>
): void {
  CandidateStore.update((s) => {
    const candidate = {
      ...s.candidate,
      ...fieldsToUpdate,
    } as CandidateStoreProps['candidate'];

    return {
      ...s,
      candidate,
    };
  });
}
